import { createApi } from "@reduxjs/toolkit/dist/query/react"
import {
  BILLING_CONFIGS_ENDPOINT,
  RTK_SLICE_API_LIST
} from "../../common/constants"
import { baseQuery, getTags } from "../api"
import { getQueryString } from "../../common/utils"
import { BillingConfig, BillingConfigDetails } from "../../types"
import bbApi from "../../api"

const reducerPath = "billingConfigApi"
const billingConfigPath = "billing-config"

export const billingConfigApi = createApi({
  reducerPath,
  baseQuery,
  tagTypes: [billingConfigPath],
  endpoints: builder => ({
    fetchBillingConfig: builder.query({
      query: (params: { org_id: string }) =>
        `${BILLING_CONFIGS_ENDPOINT}${getQueryString(params)}`,
      transformResponse: (responseData: BillingConfig[] | BillingConfig) => {
        if (Array.isArray(responseData)) return responseData
        if (responseData && typeof responseData === "object")
          return [responseData]
        return []
      },
      providesTags: result => getTags(billingConfigPath, "id", result)
    }),
    updateOrCreateBillingConfig: builder.mutation({
      queryFn: async (
        payload: Partial<BillingConfig> & {
          org_id: string
          details: BillingConfigDetails
        }
      ) => {
        if (!payload.id) {
          delete payload.id
        }
        const data = await bbApi.billingConfig.createOrUpdate(payload)
        return { data }
      },
      invalidatesTags: (result, error, arg) => {
        const resultData = result as
          | { status?: string; message?: string }
          | undefined
        const isErrorStatus = resultData?.status === "error"
        if (error || isErrorStatus) {
          return []
        }
        return [
          { type: billingConfigPath, id: arg.id },
          { type: billingConfigPath, id: RTK_SLICE_API_LIST }
        ]
      }
    }),
    deleteBillingConfig: builder.mutation({
      queryFn: async (id: string) => {
        const data = await bbApi.billingConfig.remove(id)
        return { data }
      },
      invalidatesTags: () => [
        { type: billingConfigPath, id: RTK_SLICE_API_LIST }
      ]
    })
  })
})

export const {
  useFetchBillingConfigQuery,
  useUpdateOrCreateBillingConfigMutation,
  useDeleteBillingConfigMutation
} = billingConfigApi
